import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ArrowsChevronDownBoldIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M12 7.443c.407 0 .795.174 1.064.48l6.038 6.861c.279.303.372.734.243 1.126-.129.392-.46.683-.865.76-.404.078-.82-.07-1.085-.385l-5.28-6c-.029-.033-.07-.052-.115-.052-.044 0-.086.019-.116.052l-5.28 6.001c-.264.316-.68.464-1.084.386-.405-.078-.736-.37-.865-.76-.13-.393-.036-.823.243-1.127l6.036-6.86c.27-.306.658-.482 1.066-.482z" transform="matrix(1 0 0 -1 0 24.135)"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
ArrowsChevronDownBoldIcon = __decorateClass([
  customElement("elm-arrows-chevron-down-bold-icon")
], ArrowsChevronDownBoldIcon);
export { ArrowsChevronDownBoldIcon };
